import {Outlet, useLocation} from 'react-router';

import KycStepLoader from './components/KycStepLoader/KycStepLoader';
import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';

const KycPageContent = () => {
  const {data} = useViewModelProvider();
  const location = useLocation();
  const shouldShowLoader = location.pathname === '/onboarding/kyc' && !data;

  if (shouldShowLoader) {
    return <KycStepLoader />;
  }

  return <Outlet />;
};

const KycPage = () => (
  <ViewModelProvider>
    <KycPageContent />
  </ViewModelProvider>
);

export default KycPage;
